export enum VISIBILITY {
  Private = 'private',
  Organization = 'organization',
  Public = 'public',
}
